import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  tribunal_selected: {}, //seleccionara el objeto de la lista de magistrados
  tribunales: []
};
export const mutations = {
  SELECT_TRIBUNAL({ context }, tribunal) {
    return (state.tribunal_selected = Object.assign({}, tribunal));
  },
  FILL_TRIBUNAL({ context }, list_tribunales) {
    let tribunales = [];
    Object.entries(list_tribunales).forEach(([key, val]) => tribunales.push(val));
    return (state.tribunales = tribunales);
  }
};
export const actions = {
  GET_ALL_TRIBUNALES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_TRIBUNAL", response.data.data.tribunales);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_TRIBUNAL({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_TRIBUNAL({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_TRIBUNAL({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllTribunales: state => {
    return state.tribunales;
  }
};
